import { LitElement, unsafeCSS } from "lit";
import styles from "@/index.css?inline";
import { restoreReflectedDefaults } from "./restore-defaults";

export abstract class EkoElement extends LitElement {
  static styles = [unsafeCSS(styles)];

  willUpdate(changedProperties: Map<PropertyKey, unknown>) {
    super.willUpdate(changedProperties);
    restoreReflectedDefaults(this, changedProperties);
  }

  // Use getter instead of @state & firstUpdated() to prevent triggering a re-render
  protected get parentComponent(): string | null {
    if (this.assignedSlot) {
      const hostElement = this.assignedSlot.getRootNode() as ShadowRoot;
      const parentComponent = hostElement?.host;

      if (parentComponent) {
        return parentComponent.tagName.toLowerCase();
      }
    }
    return null;
  }
}

export default EkoElement;
